module.exports = __webpack_public_path__ + "static/media/lyft.bfb5f7ca.png";